module.exports = __webpack_public_path__ + "static/media/blueSave.bf99159d.svg";